import Draggable from "react-draggable";
import { BigButton } from "./BigButton"; // The default
import { FaCheck, FaTimes } from "react-icons/fa";
import { cleanBorder, errorColor, goodColor, primary45 } from "../../utils/colors";
import {useEffect, useState} from "react";

export default function DraggableSignature({bounds, url, onEnd, onSet, onCancel }) {

  const [position, setPosition] = useState({x: 0, y: 0});

  const styles = {
    container: {
      position: "absolute",
      zIndex: 100000,
      border: `2px solid ${primary45}`,
    },
    controls: {
      position: "absolute",
      right: '-50px',
      display: "inline-block",
      backgroundColor: primary45,
      // borderRadius: 4,

    },
    smallButton: {
      display: "inline-block",
      cursor: "pointer",
      padding: 4,
    },
  };

  const handleDrag = (e, ui) => {
    // Ограничиваем положение только в пределах bounds
    const x = Math.min(Math.max(ui.x, bounds.left), bounds.right);
    const y = Math.min(Math.max(ui.y, bounds.top), bounds.bottom);

    setPosition({ x, y });
  };

  useEffect(() => {
      onEnd(position);
  }, [position]);
  return (
      <Draggable  bounds={bounds} onDrag={handleDrag}   position={{x: position?.x, y:position?.y}}>
        <div style={styles.container}>
          <div style={styles.controls}>
            <div style={styles.smallButton} onClick={onSet}>
              <FaCheck color={goodColor} />
            </div>
            <div style={styles.smallButton} onClick={onCancel}>
              <FaTimes color={errorColor} />
            </div>
          </div>
          <img src={url} width={150} style={styles.img} draggable={false} />
        </div>
      </Draggable>
  );
}
